<div *ngIf="formObject">
  <mat-form-field appearance="fill" class="w-100">
    <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">{{label}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <textarea matInput #inputElement
              requireObject [initialValue]="initialString"
              [required]="required"
              [disabled]="isDisabled"
              [placeholder]="label"
              [maxlength]="lengthLimitation"
              [name]="elementName"
              [rows]="rows"
              [matAutocomplete]="auto"
              [(ngModel)]="ngModelObject"
              (focusin)="getOptions(ngModelObject)"
              (focusout)="checkInputValidity()"
              (ngModelChange)="emitChangeToGetOptions($event, inputElement)">
    </textarea>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedOption($event)">
      <mat-option *ngFor="let option of options" [value]="option">
        {{option}}
      </mat-option>
    </mat-autocomplete>
    <mat-error>
      {{'forms.common.error_message.pick_from_list' | translate}}
    </mat-error>
    <mat-hint *ngIf="lengthLimitation" align="end">{{inputElement.value.length}} / {{lengthLimitation}}</mat-hint>
  </mat-form-field>
</div>
